import { request } from '../utils/request';

/**
 * 用户分页列表（用户管理模块）
 * 接口: POST /api/User/GetPageList
 * 响应: res_content 为 { total, pageIndex, pageSize, items }
 */
export const getPageList = (data = {}) => {
  return request({
    url: 'User/GetPageList',
    method: 'post',
    data: {
      pageIndex: data.pageIndex ?? 1,
      pageSize: data.pageSize ?? 20,
      loginId: data.loginId ?? '',
      username: data.username ?? '',
      phone: data.phone ?? '',
      email: data.email ?? '',
      status: data.status ?? undefined,
      isLock: data.isLock ?? undefined,
      source: data.source ?? '',
      unionId: data.unionId ?? '',
    },
  });
};

/**
 * 获取用户详情
 * 接口: GET /api/User/GetDetail?id=xxx
 */
export const getDetail = (params) => {
  return request({
    url: 'User/GetDetail',
    method: 'get',
    params: { id: params?.id },
  });
};

/**
 * 新增用户
 * 接口: POST /api/User/Add
 * 返回: res_content 为新用户 ID
 */
export const addUser = (data) => {
  return request({
    url: 'User/Add',
    method: 'post',
    data,
  });
};

/**
 * 更新用户
 * 接口: POST /api/User/Update
 */
export const updateUser = (data) => {
  return request({
    url: 'User/Update',
    method: 'post',
    data,
  });
};

/**
 * 批量更新用户状态
 * 接口: POST /api/User/UpdateStatus
 * 请求体: { status: 0|1, ids: number[] }
 */
export const updateStatus = (data) => {
  return request({
    url: 'User/UpdateStatus',
    method: 'post',
    data: { status: data.status, ids: data.ids },
  });
};

/**
 * 批量删除用户（逻辑删除）
 * 接口: POST /api/User/Delete
 * 请求体: { ids: number[] }
 */
export const deleteUsers = (data) => {
  return request({
    url: 'User/Delete',
    method: 'post',
    data: { ids: data.ids },
  });
};

/**
 * 获取用户下拉（LoginId）- 人员系统权限新增/编辑的用户下拉
 * 接口: GET /api/auth/User/GetUserDropdownByLoginId，无参数
 * 返回: res_content 为 List<BaseResultKV<string>>，即 [{ key, value }] 或 [{ Key, Value }]
 */
export const getUserDropdownByLoginId = () => {
  return request({
    url: 'User/GetUserDropdownByLoginId',
    method: 'get',
  });
};

/**
 * 获取用户下拉（UnionId）- 管理端注册的系统管理员、绑定用户下拉
 * 接口: GET /api/auth/User/GetUserDropdownByUnionId，无参数
 * 返回: res_content 为 List<BaseResultKV<string>>，即 [{ key, value }] 或 [{ Key, Value }]
 */
export const getUserDropdownByUnionId = () => {
  return request({
    url: 'User/GetUserDropdownByUnionId',
    method: 'get',
  });
};
